import React from 'react';
import { InfoBadge } from './InfoBadge';
import {
  getTradeBadgeColor,
  getTradeDisplayName,
  getTradeShortLabel,
  resolveTradeIdentity,
} from '../../config/tradeConfig';

/**
 * Trade identity chip — the ONLY way to render a trade code/category badge.
 *
 * Colors come from `config/tradeConfig.js` (department inheritance when the
 * trade shares identity with a department; semantic own colors otherwise).
 *
 * @param {string} [code] - TradeCategory.trade_code (preferred dense label)
 * @param {string} [name] - Full trade name (tooltip / fallback)
 * @param {object|string} [trade] - TradeCategory-like object, or a name/code string
 * @param {'xs'|'md'} [size] - InfoBadge size (default xs for dense tables)
 * @param {string} [className]
 */
export const TradeBadge = ({ code, name, trade, size = 'xs', className = '' }) => {
  const { code: tradeCode, name: tradeName } = resolveTradeIdentity(code, name, trade);
  if (!tradeCode && !tradeName) return null;

  const label = getTradeShortLabel(tradeCode, tradeName);
  if (!label) return null;

  return (
    <InfoBadge
      color={getTradeBadgeColor(tradeCode, tradeName)}
      label={label}
      title={getTradeDisplayName(tradeCode, tradeName)}
      size={size}
      className={className}
    />
  );
};

export default TradeBadge;
